<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <base-form :schema="schemas" />
  </div>
</template>

<script>
import { VTextarea } from 'vuetify/lib/components'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import FileUpload from '@/model/baseForm/fields/FileUpload.vue'
import EnhancedImageUploader from '@/model/baseForm/fields/EnhancedImageUploader.vue'

const schemas = [
  {
    key: 'logo',
    name: 'Logo',
    component: EnhancedImageUploader
  },
  {
    key: 'brandName',
    name: 'BrandName'
  },
  {
    key: 'brandDisplayName',
    name: 'BrandDisplayName'
  },
  { key: 'slogan' },
  {
    key: 'description',
    component: VTextarea
  },

  {
    key: 'documents',
    name: 'ContractTemplate',
    component: FileUpload,
    componentProps: {
      multiple: true
    }
  },
  {
    key: 'otherFiles',
    name: 'FrequentlyUsedFiles',
    component: FileUpload
  }

]
export default {
  name: 'BrandingSetting',
  components: {
    BaseForm
  },
  data () {
    return {
      schemas,
      userPic: null,
      brandName: ''
    }
  },
  methods: {
    async processFile (event) {
      this.userPic = URL.createObjectURL(event)
    }
  }
}
</script>

<style scoped>

</style>
